import styled from 'styled-components';
import { Stack } from '@koob/margaret';
import { MailTo } from 'ui';
import Avatar from 'components/Avatar';
import { upperFirst } from 'lodash';

const Name = styled.span`
  font-weight: 600;
`;

const Sublabel = styled.span`
  color: ${({ theme }) => theme.textLight};
  margin: 0;
`;

const AvatarAndName = ({ user }) => (
  <Stack direction="row" marginTop={0.5} gutterSize={0.5}>
    <Avatar
      firstName={user?.firstName}
      lastName={user?.lastName}
      imageUrl={encodeURI(user?.avatarUrl || user?.avatar?.imageUrl)}
    />

    <Stack direction="column">
      <Name>
        {upperFirst(user?.firstName)} {upperFirst(user?.lastName)}
      </Name>
      <Sublabel>{upperFirst(user?.job)}</Sublabel>

      <Stack direction="row" gutterSize={0.5}>
        {Boolean(user?.email) && (
          <MailTo href={`mailto:${user?.email}`}>
            <i className="fa-regular fa-envelope" style={{ fontSize: 18 }} />{' '}
            {user?.email}
          </MailTo>
        )}
        {Boolean(user?.phoneNumber) && (
          <MailTo href={`tel:${user?.phoneNumber}`}>
            <i className="fa-regular fa-phone" style={{ fontSize: 18 }} />{' '}
            {user?.phoneNumber}
          </MailTo>
        )}
      </Stack>
    </Stack>
  </Stack>
);

export default AvatarAndName;
